/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { DataQuery } from '@typescript-kit/data';
import { HttpService } from '@angular-kit/core';

import { Balance, BalanceData } from '@teamworks/global';

@Injectable()
export class BalanceService {

  constructor(private httpService: HttpService) {
  }

  async loadBalanceList(employeeId: string, dataQuery?: DataQuery): Promise<Balance[]> {
    return this.httpService.get(`api/time-recording/balance-list/${employeeId}`, { 'data-query': dataQuery })
      .then((loadedData: BalanceData[]) => loadedData.map(data => new Balance(data)));
  }

  async loadBalance(employeeId: string, type: string, date: string, dataQuery?: DataQuery): Promise<Balance> {
    return this.httpService.get(`api/time-recording/balance/${employeeId}/${type}/${date}`, { 'data-query': dataQuery })
      .then((loadedData: BalanceData) => loadedData && new Balance(loadedData));
  }

  async saveBalance(data: BalanceData): Promise<Balance> {
    return this.httpService.post(`api/time-recording/balance`, data)
      .then((savedData: BalanceData) => new Balance(savedData));
  }

  async deleteBalance(employeeId: string, type: string, date: string): Promise<Balance> {
    return this.httpService.delete(`api/time-recording/balance/${employeeId}/${type}/${date}`)
      .then((deletedData: BalanceData) => new Balance(deletedData));
  }
}
